import { create } from 'zustand';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

interface NavigationStore {
  previousPath: string | null;
  currentPath: string | null;
  setPreviousPath: (path: string) => void;
  setCurrentPath: (path: string) => void;
}

export const useNavigationStore = create<NavigationStore>(set => ({
  previousPath: null,
  currentPath: null,
  setPreviousPath: path => set({ previousPath: path }),
  setCurrentPath: path => set({ currentPath: path }),
}));

export function useTrackNavigation() {
  const pathname = usePathname();
  const { currentPath, setPreviousPath, setCurrentPath } = useNavigationStore();

  useEffect(() => {
    if (currentPath && currentPath !== pathname) {
      setPreviousPath(currentPath);
    }
    setCurrentPath(pathname);
  }, [pathname, currentPath, setPreviousPath, setCurrentPath]);
}
